export class ScreenProvider {
  getHTMLAndBody() {
    const body = document.querySelector('body');
    const html = document.querySelector('html');

    return { body, html };
  }

  hideScrollOnBody() {
    const { body, html } = this.getHTMLAndBody();

    body.style.overflow = 'hidden';
    html.style.overflow = 'hidden';
  }

  setScrollOnBody() {
    const { body, html } = this.getHTMLAndBody();

    body.style.overflow = 'auto';
    html.style.overflow = 'auto';
  }
}